var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-box-wrapper",class:{highlight: !!_vm.value}},[_c('el-input',{attrs:{"value":_vm.value,"placeholder":"过滤菜单...","size":"mini","suffix-icon":"el-icon-search","clearable":""},on:{"input":_vm.valueChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }